import React from 'react';
import { Button, Form, Input } from 'antd';
import { withTranslation } from 'react-i18next';

const APIKeyCreationForm = Form.create({ name: 'api-key-new' })(
  withTranslation()((props) => {
    const { t } = props;
    const { getFieldDecorator } = props.form;
    const submit = () => {
      props.form.validateFields((err, values) => {
        if (!err) {
          return props.onSubmit(values.name);
        }
      });
    };

    return (
      <Form>
        <Form.Item label={t('api_key.reference')} style={{ marginBottom: 0 }}>
          {getFieldDecorator('name', {
            rules: [
              {
                required: true,
                message: t('api_key.required.name'),
              },
            ],
          })(<Input name="name" />)}
        </Form.Item>

        <Form.Item style={{ marginTop: '20px' }}>
          <Button loading={props.loading || false} onClick={() => submit()} type="primary">
            {t('create')}
          </Button>
        </Form.Item>
      </Form>
    );
  }),
);

export default APIKeyCreationForm;
